import { HTMLSelectListItemRenderer, theme } from '@acies/ui';

export class FlagListItemRenderer extends HTMLSelectListItemRenderer {
	public constructor() {
		super();
		this.autoLayout = 'vertical';
		this.width = 'fill';
		this.height = 'hug';
		this.paddingHorizontal = 16;
		this.paddingVertical = 12;
		this.cornerRadius = 8;
		this.gapVertical = 8;
		this.cursor = 'pointer';
	}

	protected override updateIdleStyles(): void {
		super.updateIdleStyles();
		this.stroke = theme.strokes.soft;
		this.fill = theme.colors.fill.white;
	}

	protected override updateSelectedStyles(): void {
		super.updateSelectedStyles();
		this.stroke = theme.strokes.sub;
	}
}
customElements.define('ac-flag-list-item-renderer', FlagListItemRenderer);
